import { useState } from 'react'
import styled, { createGlobalStyle } from 'styled-components'
import OpenGraph from 'common/open-graph'
import Navigation from 'components/navigation'
import Wrapper from 'common/wrapper'
import Footer from 'common/footer'
import data, { firstSection, options } from 'components/pokedex/pokedex-data'
import CodeStylesMonokai from 'components/pokedex/code-styles-monokai'
import TabsBar from 'common/tabs-bar'
import Tabs from 'common/tabs'
import Introduction from 'components/pokedex/introduction.md'
import ComparationSection from 'common/comparation-section'
import MDStyles from 'post/styles'
import blogFontFace from 'common/blog-fontface'
import PokedexLinks from 'components/pokedex/pokedex-links'

const GlobalStyle = createGlobalStyle`
  code {
    padding: 0 2px;
    background: var(--neutral100);
    color: var(--lightBlue);
  }
  pre code {
    overflow: auto;
    color: var(--white);
    display: block;
    background: var(--neutral100);
    border-radius: 4px;
    padding: 16px;
    margin: 16px 0 32px;
  }
`

const NavigationWrapper = styled.div`
  overflow-x: hidden;
  h1 {
    display: block;
    margin-block-end: 48px;
  }
  .pokedex-container {
    padding-block-start: 120px;
    @media (min-width: 768px) {
      padding-block-start: 120px;
    }
  }
`

function Pokedex() {
  const [tabActive, setTabActive] = useState(options[0].id)
  const [link, setLink] = useState('')
  const handleActiveBar = (id) => {
    setTabActive(id)
    setTimeout(() => {
      const actualScroll = document.documentElement.scrollTop || document.body.scrollTop
      const scroll = actualScroll - 116
      window.scroll({
        top: scroll,
        left: 0,
        behavior: 'auto',
      })
    }, 800)
  }

  return (
    <>
      <GlobalStyle />
      <CodeStylesMonokai />
      <OpenGraph
        title="Aprende a programar creando una Pokedex y el API de Pokemon"
        description="Comparamos los frameworks de desarrollo web modernos React, Vue, Svelte y Angular. Sus ventajas y desventajas. ¿Cuál es mejor y cual es el que debes aprender primero?"
        keyword="React vs Vue vs Svelte vs Angular, ¿Cuál es mejor?, ¿Cuál aprender primero?"
      />
      <PokedexLinks />
      <NavigationWrapper>
        <Navigation position={{ mobile: 'fixed', desktop: 'static' }} color="var(--baseSecondary)" />
        <MDStyles>
          <Wrapper maxWidth={700}>
            <Introduction />
            <ComparationSection
              setLink={setLink}
              tabActive={tabActive}
              data={firstSection}
              noTabs
            />
          </Wrapper>
        </MDStyles>
      </NavigationWrapper>
      <TabsBar
        options={options}
        tabActive={tabActive}
        setTabActive={handleActiveBar}
        position="sticky"
        maxWidth={700}
        link={link}
      />
      <Wrapper maxWidth={700}>
        <MDStyles>
          <Tabs options={firstSection.tabs} tabActive={tabActive} />
          {data.map((option) => (
            <ComparationSection
              setLink={setLink}
              tabActive={tabActive}
              key={option.id}
              data={option}
            />
          ))}
        </MDStyles>
      </Wrapper>
      <Footer />
    </>
  )
}

Pokedex.pageTheme = blogFontFace

export default Pokedex
